import { useEffect, useState } from "react"

import { OrderPreview, Calendar, ChartSection, QuickView } from "../../components/Home"
import { getOrders } from "../../service/api/Order/apiOrder"

const Home = () => {
    const [ordersData, setOrdersData] = useState([]);

    useEffect(() => {
        getOrders()
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setOrdersData(response.data.result);
                }
            });
    }, []);

    return (
        <>
            <main>
                <div className="container-fluid px-4">
                    <h1 className="mt-4">訂單資訊一覽</h1>
                    <ol className="breadcrumb mb-4">
                        <li className="breadcrumb-item active">訂單數據快覽</li>
                    </ol>
                    <div className="row mt-4">
                    <div className="row">
                        <QuickView
                        data={ordersData} />
                    </div>
                        <div className="row d-flex align-items-stretch">
                            {/* 統計圖條 */}
                            <div className="col-lg-6 mb-4">
                                <div className="card h-100">
                                    <ChartSection
                                        data={ordersData} />
                                </div>
                            </div>

                            {/* 訂單預覽 */}
                            <div className="col-lg-6 mb-4">
                                <div className="card h-100">
                                    <OrderPreview
                                        data={ordersData} />
                                </div>
                            </div>

                            {/* 排程表預覽 */}
                            <div className="col-lg-12 mb-4">
                                <div className="card">
                                    <Calendar
                                        data={ordersData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            {/* 頁面footer 可預留 */}
            {/* <footer className="py-4 bg-light mt-auto">
                        <div className="container-fluid px-4">
                            <div className="d-flex align-items-center justify-content-between small">
                                <div className="text-muted">Copyright &copy; Your Website 2023</div>
                                <div>
                                    <Link href="#">Privacy Policy</Link>
                                    &middot;
                                    <Link href="#">Terms &amp; Conditions</Link>
                                </div>
                                <div className="text-muted">Copyright &copy; Your Website 2023</div>
                            </div>
                        </div>
                    </footer> */}
        </>
    )
}

export { Home }